"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UIDConsumer = exports.ImportedStream = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var context = _react.default.createContext ? _react.default.createContext() : null;
var UID = 1;

var ImportedStream =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ImportedStream, _React$Component);

  function ImportedStream(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ImportedStream);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImportedStream).call(this, props));
    _this.UID = UID++;

    if (!_this.props.takeUID) {
      throw new Error('You have to provide takeUID prop to ImportedStream');
    }

    _this.props.takeUID(_this.UID);

    return _this;
  }

  (0, _createClass2.default)(ImportedStream, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(context.Provider, {
        value: this.UID
      }, this.props.children);
    }
  }]);
  return ImportedStream;
}(_react.default.Component);

exports.ImportedStream = ImportedStream;
ImportedStream.propTypes = process.env.NODE_ENV !== "production" ? {
  takeUID: _propTypes.default.func.isRequired,
  children: _propTypes.default.node
} : {};

var PassThrough = function PassThrough(_ref) {
  var children = _ref.children;
  return children(0);
};

PassThrough.propTypes = {
  children: _propTypes.default.func.isRequired
};
var UIDConsumer = context ? context.Consumer : PassThrough;
exports.UIDConsumer = UIDConsumer;